import * as _4 from 'lodash4';
export class AccountTokenServant {
  constructor() {
    return AccountTokenServant;
  }

  static accumulateAccountProperties(accountToken: { userdata: any }) {
    let mergedAccountToken = _4.merge({}, accountToken);
    if (accountToken && accountToken.userdata) {
      mergedAccountToken = _4.merge(mergedAccountToken, accountToken.userdata);
    }
    if (mergedAccountToken.userdata) {
      mergedAccountToken.userdata = undefined;
    }
    return mergedAccountToken;
  }

  static isUserAlreadyLoggedIn(accountToken: { userdata: any }) {
    return _4.size(accountToken) > 0;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/servants/account_token_servant.ts